

/**
 * [menus description]
 * @return {[type]} [description]
 */
var menus = function(){


	/**
	 * [items description]
	 * @return {[type]} [description]
	 */
	this.items = function()
	{

		var sortable;

		/**
		 * [bindMiscModalEvents description]
		 * @param  {[type]} modalObj [description]
		 * @return {[type]}          [description]
		 */
		var bindMiscModalEvents = function( modalObj )
		{
			var forType = $('#for', modalObj);
			var container = $('#type-list', modalObj);
			var route = $('#refresh-list-route', modalObj);
            $.fn.ensphere.veto.wysiwyg( '.wysiwyg', container );
            $.fn.ensphere.veto.refreshModal();
			forType.unbind('change').change(function(){
				$.get( route.val() + '/?type=' + forType.val(), function( response ){
					response = $(response);
					container.replaceWith( response );
					$.fn.ensphere.veto.wysiwyg( '.wysiwyg', response );
					$.fn.ensphere.veto.refreshModal();
					bindMiscModalEvents();
				});
			});
		};

		/**
		 * [updateMenuItemsRows description]
		 * @param  {[type]} model      [description]
		 * @param  {[type]} attributes [description]
		 * @param  {[type]} modal      [description]
		 * @return {[type]}            [description]
		 */
		var updateMenuItemsRows = function( model, attributes, modal )
		{
			var row = $('[data-row-id="' + model.id + '"]');
			$( '> div > span:eq(1)', row).text( model.text );
		};

		/**
		 * [addMenuItemsRows description]
		 * @param {[type]} response   [description]
		 * @param {[type]} attributes [description]
		 * @param {[type]} modal      [description]
		 */
		var addMenuItemsRows = function( model, attributes, modal )
		{

			$('.disabled.empty').remove();

			var row = $('<li />')
				.attr('data-row-id', model.id)
				.attr('data-row-indent', '0' )
				.attr('data-row-parent-id', '0' );
			var buttons = $('<div />')
				.addClass('btn-group').appendTo(row);
			var mover = $('<span class="drag-handle btn btn-default"><i class="fa fa-arrows"></i></span>').appendTo(buttons);
			var text = $('<span class="btn btn-default"></span>').text( model.text ).appendTo(buttons);
			var editButton = $('<a data-for="edit-menu-item" class="btn btn-default"><i class="fa fa-pencil-square-o"></i></a>')
				.attr('data-for-row-id', model.id)
				.attr('href', model.edit_url).appendTo(buttons);
			var deleteButton = $('<a data-for="delete-menu-item" class="btn btn-danger"><i class="fa fa-trash"></i></a>')
				.attr('data-for-row-id', model.id)
				.attr('href', model.delete_url).appendTo(buttons);


			row.appendTo(sortable);
			sortable.data( 'sortable-api' ).addItem(row);

		};

		/**
		 * [editItemHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var editItemHandler = function(e)
		{
			e.preventDefault();
			$('.ui.form').addClass('loading');
            $.fn.ensphere.veto.modalEdit( this, {
				onVisible : function( modalObj ){
					bindMiscModalEvents( modalObj );
				},
				onComplete : function( response, attributes, modal ){
					modal.semanticUiModal('hide');
					updateMenuItemsRows( response, attributes, modal );
				},
				onHidden : function(){
					$('.ui.form').removeClass('loading');
				}
			});
		};

		/**
		 * [addItemHandler description]
		 * @param {[type]} e [description]
		 */
		var addItemHandler = function(e)
		{
			e.preventDefault();
			$('.ui.form').addClass('loading');
            $.fn.ensphere.veto.modalEdit( this, {
				onVisible : function( modalObj ){
					bindMiscModalEvents( modalObj );
				},
				onComplete : function( response, attributes, modal ){
					modal.semanticUiModal('hide');
					addMenuItemsRows( response, attributes, modal );
                    $('.sortable-menu').data( 'sortable-api' ).reOrder();
                    $('.sortable-menu').data( 'sortable-api' ).reSetHeight();
				},
				onHidden : function(){
					$('.ui.form').removeClass('loading');
				}
			});
		};

		/**
		 * [deleteItemHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var deleteItemHandler = function(e)
		{
            e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onResponse : function( response, attributes ){
					$('.ui.form').removeClass('loading');
					$('li[data-row-id="' + response.id + '"]', sortable).fadeOut( 200, function(){
						$(this).data( 'sortable' ).remove();
						$(this).remove();
					});
				}
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
            $.fn.ensphere.veto.clickEvent( $.fn.ensphere.veto.singleSelect('[data-for="add-menu-item"]'), addItemHandler );

            $('.sortable-menu').on( 'click.ensphere-sortable', '[data-for="edit-menu-item"]', editItemHandler );
            $('.sortable-menu').on( 'click.ensphere-sortable', '[data-for="delete-menu-item"]', deleteItemHandler );

		};

		/**
		 * [sortableMenu description]
		 * @return {[type]} [description]
		 */
		var sortableMenu = function()
		{
			sortable = $('.sortable-menu').sortableMenu({
				container : document.getElementById( 'menu-wrapper' )
			});
			sortable.bind('dropped', function(){
				bindEvents();
			});
		};

		var ensphereSortable = function()
		{
			sortable = $('.sortable-menu').ensphereSortable();
            $('#update-menu').click(function(e){
                $('<input />')
                    .attr( 'type', 'hidden' )
                    .attr( 'name', 'ordering' )
                    .val( sortable.data( 'sortable-api' ).serializeData() )
                    .appendTo( $( '#menu-form' ) );
            });
		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				bindEvents();
				ensphereSortable();
				// sortableMenu();
			};
		};
	};

};

jQuery(document).ready( function($){

	if( $('.edit.menu').length ) {
		var app = new menus();
		var item = app.items();
		item.init();
	}

});
